<template>
  <div>
    <div class="cont">
      <div class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>工程概况</el-breadcrumb-item>
          <el-breadcrumb-item>项目概况</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="box">
        <div class="box-r">
          <div class="box-r-t">
            <div class="box-r-t-l">
              <div>
                <el-input @change="search" v-model="form.surveyName" clearable placeholder="请输入内容"></el-input>
              </div>
              <div style="margin-left:30px" @click="search">查询</div>
            </div>
            <div class="box-r-t-r">
              <div style="margin-right:10px" @click="enter1">创建项目</div>
              
            </div>
          </div>
          <div class="box-r-b">
            <div style="padding:0 8px">
              <el-table
              border
              :header-cell-style="{background:'#F5F7F9',color: '#909399',fontFamily: 'MicrosoftYaHei',fontSize:'16px'}"
              height="66vh"
              :data="tableData"
              style="width: 100%">
              <el-table-column
                prop="index"
                label="序号"
                width="100"
                >
              </el-table-column>
              <el-table-column
                prop="surveyName"
                label="项目名称"
                >
              </el-table-column>
              <el-table-column
                prop="projectAddress"
                label="项目地址">
              </el-table-column>
              <el-table-column
                width="220"
                prop="createTime"
                label="创建时间">
              </el-table-column>
              <el-table-column
                label="操作"
                width="110">
                <template slot-scope="scope">
                  <div style="display:flex">
                    <el-button @click="enter(scope.row)" size="mini" type="primary" plain>编辑</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            </div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.pageNum"
              :page-sizes="[1,20, 50, 100, 200,500]"
              :page-size="form.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
            <!-- 弹窗 -->
           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
  export default {
    data() {
      return {
        tableData: [],
        total:0,
        form:{
          pageSize:20,
          pageNum:1,
          groupId:util.session.get('groupId'),
          surveyName:''
        }

      }
    },
    mounted(){
      this.getList()
    },
    methods:{
     handleSizeChange(val){
        this.form.pageSize = val
        this.form.pageNum = 1
        // this.getPartyBuildingActiveFileByPartybuildId(this.listItemId)
        this.getList()
      },
      handleCurrentChange(val){
        this.form.pageNum = val
        // this.getPartyBuildingActiveFileByPartybuildId(this.listItemId)
        this.getList()
      },
      getList(){
        myHttp.getProjectSurveyList(this.form).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.tableData=res.data.data.list.list
            this.total = res.data.data.list.total
            this.tableData.forEach((item,index)=>{
              item['index']=(this.form.pageNum-1)*this.form.pageSize+index+1
            })
          }
        })
      },
      search(){
        this.form.pageNum = 1
        this.getList()
      },
      enter(item){
        this.$router.push({
          path:'/createProjectOverview',
          query:{
            id:item.surveyId,
            type:2
          }
        })
      },
      enter1(){
        this.$router.push({
          path:'/createProjectOverview',
          query:{
            type:1
          }
        })
      }
    }
  }
</script>

<style scoped>
.cont{
  width: 100%;
  height: 100%;
  background-color: rgb(236,240,245);
  padding: 0 24px 10px 8px;
}
.title{
  height: 4vh;
  display: flex;
  align-items: center;
}
.box{
  display: flex;
  height: 78vh;
}

.box-r{
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 5px 4px 10px -2px rgba(0, 0, 0, 0.25);
  flex: 1;
  overflow: hidden;
}
.box-r-t{
  height: 6vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
}
.box-r-t-l{
  /* width: 12vw; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box-r-t-r{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box-r-t-l>div:nth-child(2),.box-r-t-r>div{
  width: 70px;
height: 40px;
border-radius: 2px;
background: #409EFF;
font-family: MicrosoftYaHei;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #FFFFFF;
display: flex;
  justify-content: center;
  align-items: center;
}
.box-r-t-l>div:nth-child(2):hover,.box-r-t-r>div:hover{
  cursor: pointer;
  opacity: 0.7;
}
.box-r-b{
  /* background-color: #f00; */
  height: 72vh;
  
}
.el-pagination{
  box-shadow: 0px -10px 21px 0px rgba(225, 225, 225, 0.3);
}
::v-deep .cell>span{
  font-size: 14px !important;
}
::v-deep .cell{
  font-size: 14px !important;
}
::v-deep .el-dialog__header{
  text-align: start;
 
background: #F1F1F1;
}
::v-deep .el-dialog__header >.el-dialog__title{
 font-size: 16px ;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
.row{
  height: 4vh;
  margin-bottom: 1vh;
  width: 100%;
  display: flex;
  padding-left:1vw;
  align-items: center;
}
.row>div:nth-child(1){
  font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #9E9E9E;
}
.row>div:nth-child(2){
  width: 11vw;
  height: 100%;
}
::v-deep .el-dialog{
  border-radius: 6px;
  overflow: hidden;
}
.dialog-footer{
  display: flex;
  justify-content: center;
}
::v-deep .el-tree-node__expand-icon .is-leaf{
  color:transparent !important;
}
</style>